module.exports = __webpack_public_path__ + "assets/img/banner-challenge.70b0cdac.jpg";